<template>
    <!-- <div v-if="isWechat && !isClose && showConfig" class="open-app">
        <div class="open-app-box">
            <i class="close-btn" @click="isClose = true"></i>
            <div class="logo-box">
                
            </div>
            <div class="info-box">
                <p class="name">伟东云</p>
            </div>
            <div class="btn-box">
                <wx-open-launch-app 
                    id="launch-btn" 
                    @error="handelError"
                    @launch="handelLaunch" 
                    appid="wx4e46cf1480ebf43c" 
                    :extinfo="pageName"
                >
                    <script type="text/wxtag-template">
                        <style>
                            .btn-open-weapp {
                                background-color: #1F94FF;
                                width: 5.3rem;
                                height: 2.2rem;
                                border: 0 none;
                                border-radius: 1.06rem;
                                font-size: 0.8rem;
                                font-weight: normal;
                                color: #fff;
                                outline: none;
                            }
                        </style>
                        <button class="btn-open-weapp">
                            打开APP
                        </button>
                    </script>
                </wx-open-launch-app>
            </div>
        </div>
    </div> -->
    <div v-if="!isApp && showConfig && showTip">
        <div class="toApp-tip-gd">
			<div class="tip-text" @click="togoApp">
				<img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/c-h5-fe/study/wd-logo.png" />
				<span>打开app，查看更多感兴趣的内容</span>
			</div>
			<div class="close-tip" @click="closeTip">
				<img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/c-h5-fe/study/close-toApp.png"/>
			</div>
		</div>
        <div class="mb-toapp"></div>
    </div>
</template>
<script>
export default {
    props: {
        pageName: {
            type: String,
            default: '',
            androidApk: '',
        }
    },
    data() {
        return {
            // showConfig: false,
            // isClose: false,
            // isWechat: this.$publicFn.getUserAgent() === 'wechat',
            // goodsId: this.$route.query.goodsId,
            // goodsKinds: this.$route.query.goodsKinds,
            showTip:true,
            isApp:false
        }
    },
    created() {
        this.getShowConfig();
        this.$WDJSBridge.useGetAppVersion().then(res=>{
          console.log('获取版本号成功', res)
          this.isApp = res?true:false;
        }).catch(err=>{
          console.log('获取版本号失败', err)
        })
    },
    methods: {
        closeTip(){
			this.showTip=false;
		},
		togoApp(){
			this.$router.push({
				path: '/downloadApp',
			})
		},
        // handelLaunch(data) {
        //     console.log('launch', data)
        // },
        // getAndroidApk() {
        //     this.$api.common.findByVersionNum({
        //         client: 2,
        //     }).then((res)=>{
        //         if(res.success) {
        //             this.androidApk = res.data.upgradeAddr;
        //         }
        //     })
        // },
        // handelError(data) {
        //     const ua = window.navigator.userAgent.toLowerCase();
        //     const isIos= /iphone|ipad|ipod/.test(ua);
        //     const url = isIos ? 'https://apps.apple.com/cn/app/%E4%BC%9F%E4%B8%9C%E4%BA%91/id1616598418': 
        //         'http://zhushou.360.cn/detail/index/soft_id/4639484?recrefer=SE_D_%E4%BC%9F%E4%B8%9C%E4%BA%91';
        //     window.open(url)
        //     console.log('error', data, data.detail)
        // },
        getShowConfig() {
            const frontendConfig = this.$store.state.dynamic.frontendConfig || [];
            frontendConfig.forEach((item) => {
                console.log(item.key)
                if(item.key === 'is_show_downloadApp') {
                    this.showConfig = item.value == 'true';
                    // if(this.showConfig) {
                    //     this.getAndroidApk();
                    // }
                }
            });
        }
    },
}
</script>

<style lang="less" scoped>
    .toApp-tip-gd{
        position :fixed;
        z-index:100;
        background:#1F94FF;
        display: flex;
        padding:0 40px 0 48px;
        width:100%;
        top:0;
        justify-content: space-between;
        box-sizing:border-box; 
        .tip-text{
            display: flex;
            height:80px;
            align-items: center;
            img{
                width: 70px;
                height: 30px;
            }
            span{
                font-size: 30px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 42px;
                margin-left: 42px;
            }
        }
        .close-tip{
            display: flex;
            align-items: center;
            width: 32px;
            img{
                width: 32px;
                height: 32px;
            }
        }
    }
    .mb-toapp{
        height: 80px;
    }
    // .open-app {
    //     position: fixed;
    //     left: 0;
    //     top: 0;
    //     width: 100%;
    //     z-index: 9999999099;
    //     background-color: #fff;
    //     .close-btn {
    //         position: absolute;
    //         right: 28px;
    //         top: 28px;
    //         width: 34px;
    //         height: 34px;
    //         background: url(../../asset/images/app_close.png) no-repeat center center /24px 24px;
    //     }
    //     .open-app-box {
    //         height: 160px;
    //         display: flex;
    //         padding: 30px 32px;
    //         box-sizing: border-box;
    //         align-items: center;
    //     }
    //     .logo-box {
    //         width: 100px;
    //         height: 100px;
    //         border-radius: 24px;
    //         margin-right: 24px;
    //         background-color: #1F94FF;
    //         background-image: url(../../asset/images/app_logo.png);
    //         background-size: 100% 100%;
    //     }
    //     .info-box {
    //         display: flex;
    //         align-items: center;
    //         padding: 2px 0;
    //         box-sizing: border-box;
    //         margin-right: 70px;
    //         min-width: 265px;
    //     }
    //     .info-box .name {
    //         color: #333;
    //         font-size: 30px;
    //     }
    //     .info-box .desc {
    //         color: #999;
    //         font-size: 26px;
    //     }
    //     .btn-box {
    //         width: 184px;
    //         height: 60px;
            
    //         color: #fff;
    //         font-size: 30px;
    //         line-height: 60px;
    //         font-size: 30px;
    //         text-align: center;
    //     }
    // }
</style>